module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cw-menu-item-title d-flex align-items-center" role="menuitem" tabindex="-1" data-value="'+
((__t=(index))==null?'':__t)+
'" data-ecran="'+
((__t=(menu.id))==null?'':__t)+
'">\r\n    <span class="d-flex flex-grow-1">\r\n        <a href="'+
((__t=(menu.href))==null?'':__t)+
'" tabindex="'+
((__t=(tabindex))==null?'':__t)+
'" class="'+
((__t=(menu.id))==null?'':__t)+
' d-flex flex-grow-1">\r\n            <span class="cw-menu-element d-flex align-items-center flex-grow-1">\r\n                <span class="d-flex cw-menu-item-icon flex-shrink-0"> '+
((__t=(icone))==null?'':__t)+
' </span>\r\n                <span class="ctime-menu-item-libelle ml-3">'+
((__t=(menu.nom))==null?'':__t)+
' </span>\r\n            </span>\r\n        </a>\r\n    </span>\r\n</div>\r\n';
}
return __p;
};
